import React from 'react';
import { useController } from 'react-hook-form';

// components
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';
import FormFieldDescription from '../FormFieldDescription';

const Textarea = ({ name, control, rules, label, description, ...props }) => {
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    return (
        <div className="FormField FormField--textarea">
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <textarea
                {...props}
                id={name}
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                ref={field.ref}
                name={field.name}
            />
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
};

export default Textarea;